import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Input } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { useGetAccountNumberQuery } from '@app/api/accountApi';
import { ErrorMessage } from '@app/components/ErrorMessage';
import { PageLoader } from '@app/components/PageLoader';
import { getLegalUrl } from '@app/configs/documentsLists';
import { getUserLocale } from '@app/utils/getUserLocale';
const ACCOUNT_NUMBER = 'accountNumber';
const AdditionalBorrowerInfoForm = () => {
    const { t } = useTranslation();
    const locale = getUserLocale();
    const { setValue, register, formState: { errors: formErrors }, } = useFormContext();
    const { data: accountNumber, isLoading } = useGetAccountNumberQuery();
    useEffect(() => {
        if (accountNumber) {
            setValue('accountNumber', accountNumber);
        }
    }, [accountNumber]);
    if (isLoading) {
        return <PageLoader />;
    }
    return (<>
            <div className="mb-4">
                <Input className="w-full" id="phoneNumber" placeholder="+370 000 00000" {...register('phoneNumber')} label={t('financing.loan_application.additional_phone_number')} isError={!!formErrors.phoneNumber}/>
                {formErrors.phoneNumber && (<ErrorMessage error={t('financing.loan_application.additional_info_error')}/>)}
            </div>
            <div className="mb-4">
                <Input className="w-full" id="address" placeholder={t('financing.loan_application.additional_residential_address_placeholder')} {...register('address')} label={t('financing.loan_application.additional_residential_address')} isError={!!formErrors.address}/>
            </div>
            <div className="mb-4">
                <Input className="w-full" id="email" placeholder="example@domain.com" {...register('email')} label={t('financing.loan_application.additional_email_address')} isError={!!formErrors.email}/>
                {formErrors.email && <ErrorMessage error={t('financing.loan_application.additional_info_error')}/>}
            </div>
            <div className="mb-4">
                <label htmlFor={ACCOUNT_NUMBER} className="block mb-2 label-m">
                    {t('financing.loan_application.choose_bank_account')}
                </label>
                <select id={ACCOUNT_NUMBER} className="block w-full p-2.5 body-m text-neutral-primary-initial bg-surface-neutral-primary-initial border border-neutral-primary-initial rounded-lg" {...register(ACCOUNT_NUMBER)} disabled>
                    <option key={accountNumber} value={accountNumber}>
                        {accountNumber}
                    </option>
                </select>
            </div>
            <div className="mt-6">
                <h3 className="title-s">{t('financing.loan_application.more_info')}</h3>
                <ul className="list-disc pl-5 mt-2">
                    <li>
                        <a href={getLegalUrl('serviceFee', locale)} className="body-m text-action-primary-initial hover:underline" target="_blank" rel="noreferrer">
                            {t('financing.loan_application.service_fees')}
                        </a>
                    </li>
                    <li>
                        <a href={getLegalUrl('creditworthinessRules', locale)} className="body-m text-action-primary-initial hover:underline" target="_blank" rel="noreferrer">
                            {t('financing.loan_application.creditworthiness_rules')}
                        </a>
                    </li>
                </ul>
                <p className="mt-4 body-s text-neutral-secondary-initial mb-6">
                    <span className="label-s">{t('financing.loan_application.note_label')}:</span>{' '}
                    {t('financing.loan_application.note_text')}
                </p>
            </div>
        </>);
};
export default AdditionalBorrowerInfoForm;
